document.querySelector("form")?.addEventListener("submit", function () {
  console.log("form submition");
  document.querySelector(":submit", this).attr("disabled", "disabled");
});
